// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./utils/patchFetch";
import App from "./App";
import { UserProvider } from "./context/UserContext";
import { SocketProvider } from "./context/SocketContext";
import { dbgFetch } from './utils/debug';

if (process.env.REACT_APP_DEBUG_FETCH === '1' && typeof window !== 'undefined') {
  const orig = window.fetch.bind(window);
  window.fetch = (input, init) => dbgFetch('FETCH', input, init ?? {});
  // Si besoin, garde l’original sur window.__origFetch = orig;
}


ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <SocketProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </SocketProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
